import React, {Component} from 'react';
import {SearchBox, SearchInput} from './style';
import Button from '../../../../components/button';

class Search extends Component {
	constructor(props) {
		super(props);

		this.state = {
			query: props.query || '',
			showButton: false
		};

		this.onChangeInput = this.onChangeInput.bind(this);
	}

	onChangeInput(event) {		
		const {onSearch} = this.props;

		this.setState({
			query: event.target.value,
			showButton: !!event.target.value.length
		}, () => !this.state.showButton && onSearch && onSearch(null));
	}

	render() {
		const {onSearch} = this.props;
		const {showButton, query} = this.state;

		return (
			<SearchBox showButton={showButton}>
				<SearchInput>
					<i className="icon mapsa-search" />
					<input 
						placeholder="جستجو" 
						value={query}
						onChange={event => this.onChangeInput(event)}
						onKeyPress={(event) => {
			                if (event.key === "Enter") {
			                  query && onSearch && onSearch(query)
			                }
			              }}
			            />
				</SearchInput>
				<Button btn="primary" onClick={() => query && onSearch && onSearch(query)}>جستجو</Button>
			</SearchBox>
		)
	}
}

export default Search;